module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Companies")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "company-top-actions"
  }, [(this.$sessionService.getRole() === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.createInvoiceForCompanyOrAll()
      }
    }
  }, [_c('i', {
    staticClass: "ti-money"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_add_invoice_all')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.addCompany()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" Dodaj novu kompaniju")]), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.openInvoiceReport()
      }
    }
  }, [_c('i', {
    staticClass: "ti-bar-chart"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_report')))])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-xs"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showArchived),
      expression: "showArchived"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.showArchived) ? _vm._i(_vm.showArchived, null) > -1 : (_vm.showArchived)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showArchived,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showArchived = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showArchived = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showArchived = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "report-toggle-label",
    on: {
      "click": function($event) {
        _vm.showVersionConfig = !_vm.showVersionConfig
      }
    }
  }, [_vm._v("Prikaži konfiguraciju verzija\n      "), _c('i', {
    class: _vm.showVersionConfig ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
  })]), _vm._v(" "), (_vm.showVersionConfig) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Version number")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVersionNumber),
      expression: "newVersionNumber"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": "Verzija",
      "name": "limits"
    },
    domProps: {
      "value": (_vm.newVersionNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newVersionNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.androidUpdateVersion),
      expression: "androidUpdateVersion"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox1",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.androidUpdateVersion) ? _vm._i(_vm.androidUpdateVersion, null) > -1 : (_vm.androidUpdateVersion)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.androidUpdateVersion,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.androidUpdateVersion = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.androidUpdateVersion = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.androidUpdateVersion = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.huaweiUpdateVersion),
      expression: "huaweiUpdateVersion"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox3",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.huaweiUpdateVersion) ? _vm._i(_vm.huaweiUpdateVersion, null) > -1 : (_vm.huaweiUpdateVersion)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.huaweiUpdateVersion,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.huaweiUpdateVersion = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.huaweiUpdateVersion = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.huaweiUpdateVersion = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iosUpdateVersion),
      expression: "iosUpdateVersion"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox2",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.iosUpdateVersion) ? _vm._i(_vm.iosUpdateVersion, null) > -1 : (_vm.iosUpdateVersion)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.iosUpdateVersion,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.iosUpdateVersion = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.iosUpdateVersion = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.iosUpdateVersion = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(4)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.updateVersions()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" Sacuvaj verzije")])]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Logo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("Ime kompanije")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Balans (€)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Izmeni")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Config")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Prevodi")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Door Config")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Fakture")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Izdaj Fakturu")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.showArchived ? 'Unarchive' : 'Obriši'))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredCompany), function(company) {
    return _c('tr', [_c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(company.logoUrl != null && company.logoUrl.length > 0) ? _c('img', {
      staticClass: "cropped1 user-avatar-sm",
      attrs: {
        "src": company.logoUrl
      }
    }) : _vm._e(), _vm._v(" "), (company.logoUrl == null || company.logoUrl.length === 0) ? _c('img', {
      staticClass: "cropped1-missing user-avatar-sm",
      attrs: {
        "src": require("../../assets/img/icons/missing_image.svg")
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": "Ime kompanije"
      },
      on: {
        "click": function($event) {
          return _vm.getApyKey(company.id)
        }
      }
    }, [_vm._v(_vm._s(company.displayName) + " "), _c('i', {
      staticClass: "ti-key"
    })]), _vm._v(" "), _c('td', {
      style: (company.currentBalance < 0 ? 'color:red;' : company.currentBalance === 0 ? 'color:white;' : 'color: green;'),
      attrs: {
        "data-title": "Balans"
      }
    }, [_vm._v("\n              " + _vm._s(company.currentBalance) + " €\n            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Izmeni"
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.editCompany(company)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    }), _vm._v(" Izmeni\n              ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Konfiguracija"
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.configCompany(company)
        }
      }
    }, [_c('i', {
      staticClass: "ti-settings"
    }), _vm._v(" Config\n              ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Prevodi"
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.translateCompany(company)
        }
      }
    }, [_c('i', {
      staticClass: "ti-book"
    }), _vm._v(" Prevodi\n              ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Door Config"
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.doorConfigCompany(company)
        }
      }
    }, [_c('i', {
      staticClass: "ti-key"
    }), _vm._v(" Door Config\n              ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Fakture"
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.invoices(company)
        }
      }
    }, [_c('i', {
      staticClass: "ti-money"
    }), _vm._v(" Fakture\n              ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": "Izdaj fakturu"
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.createInvoiceForCompanyOrAll(company.name)
        }
      }
    }, [_c('i', {
      staticClass: "ti-hand-open"
    }), _vm._v(" Izdaj fakturu\n              ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.showArchived ? 'Unarchive' : 'Obriši'
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteCompany(company)
        }
      }
    }, [_c('i', {
      staticClass: "ti-hand-open"
    }), _vm._v(" " + _vm._s(_vm.showArchived ? 'Unarchive' : 'Obriši') + "\n              ")])])])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("Prikaži arhivirane")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-mobile"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('label', {
    attrs: {
      "for": "checkbox1"
    }
  }, [_vm._v("Android")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('label', {
    attrs: {
      "for": "checkbox3"
    }
  }, [_vm._v("Huawei")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    attrs: {
      "for": "checkbox2"
    }
  }, [_vm._v("IOS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39f3c780!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Company/Company.vue
// module id = 741
// module chunks = 0